import React from "react";
import Categories from "../../Components/pages/categories/categories";

function Index() {
  return <Categories />;
}

export default Index;
